import React from 'react';
import '../../src/App.css';
function Contact() {
  return (
    <section id='contact-body'>
      <h1>Contact Us</h1>
    </section>
  );
}

export default Contact;
